import { IDEAL_MATCH_OPTIONS } from '../IDEAL_MATCH_OPTIONS';
import { IdealMatchOptionIdType } from '../types';

const DEFAULT: IdealMatchOptionIdType = 'casual_chatting';

export const getIdealMatchIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): IdealMatchOptionIdType | null => {
  const id = IDEAL_MATCH_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT;
  }

  return null;
};
